/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Status_RepliedInputs */

const en_settings_tickets_status_replied = /** @type {(inputs: Settings_Tickets_Status_RepliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Progress`)
};

const zh_settings_tickets_status_replied = /** @type {(inputs: Settings_Tickets_Status_RepliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理中`)
};

/**
* | output |
* | --- |
* | "In Progress" |
*
* @param {Settings_Tickets_Status_RepliedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_status_replied = /** @type {((inputs?: Settings_Tickets_Status_RepliedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Status_RepliedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_status_replied(inputs)
	return zh_settings_tickets_status_replied(inputs)
});
export { settings_tickets_status_replied as "settings.tickets.status_replied" }